const work_times = [
    { time_id: 1, time: "6:00 AM" },
    { time_id: 2, time: "6:30 AM" },
    { time_id: 3, time: "7:00 AM" },
    { time_id: 4, time: "7:30 AM" },
    { time_id: 5, time: "8:00 AM" },
    { time_id: 6, time: "8:30 AM" },
    { time_id: 7, time: "9:00 AM" },
    { time_id: 8, time: "9:30 AM" },
    { time_id: 9, time: "10:00 AM" },
    { time_id: 10, time: "10:30 AM" },
    { time_id: 11, time: "11:00 AM" },
    { time_id: 12, time: "11:30 AM" },
    { time_id: 13, time: "12:00 PM" },
    { time_id: 14, time: "12:30 PM" },
    { time_id: 15, time: "1:00 PM" },
    { time_id: 16, time: "1:30 PM" },
    { time_id: 17, time: "2:00 PM" },
    { time_id: 18, time: "2:30 PM" },
    { time_id: 19, time: "3:00 PM" },
    { time_id: 20, time: "3:30 PM" },
    { time_id: 21, time: "4:00 PM" },
    { time_id: 22, time: "4:30 PM" },
    { time_id: 23, time: "5:00 PM" },
    { time_id: 24, time: "5:30 PM" },
    { time_id: 25, time: "6:00 PM" },
    { time_id: 26, time: "6:30 PM" },
    { time_id: 27, time: "7:00 PM" },
]
  

export default work_times